import { PhotoFileLine } from './PhotoFileLine';

export interface PhotoUploadProgressProps {
  file: File;
  progress: number;
  buttonHeight: number;
  onCancel: () => void;
}

/** The file name, a progress bar and a way to stop, shown under the preview while a photo uploads. */
export function PhotoUploadProgress({
  file,
  progress,
  buttonHeight,
  onCancel,
}: PhotoUploadProgressProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
        <div style={{ minWidth: 0, flex: 1 }}>
          <PhotoFileLine file={file} />
        </div>
        <span
          className="nb-tabular"
          style={{ fontSize: 11, fontWeight: 700, color: 'var(--nb-muted)' }}
        >
          {progress}%
        </span>
      </div>
      <div
        className="nb-bar"
        role="progressbar"
        aria-label="Upload progress"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={progress}
        style={{ width: '100%', height: 5 }}
      >
        <i style={{ width: `${progress}%` }} />
      </div>
      <div style={{ fontSize: 11, color: 'var(--nb-muted)' }}>
        The current photo stays live until the upload finishes.
      </div>
      <div>
        <button
          type="button"
          className="nb-btn nb-btn-ghost"
          onClick={onCancel}
          style={{ height: buttonHeight, fontSize: 12.5 }}
        >
          Cancel upload
        </button>
      </div>
    </div>
  );
}
